import React from 'react';

/**
 * RODAPÉ DE MRR DA ASSINATURA — um componente só para os dois modais.
 *
 * ⛔ Ele existia DUAS VEZES no App.tsx (visualização e edição) e as cópias já
 * tinham divergido: a edição dizia "Subtotal MRR vigente hoje" SEMPRE, mesmo
 * sem nenhum item fora de vigência, sugerindo uma exclusão que não existia (e
 * a linha do contraponto nem aparecia). A regra certa era a da visualização:
 * o qualificador só entra quando há diferença de fato.
 *
 * O subtotal é o que VALE HOJE, que é o que vai para a fatura; o contratado só
 * aparece quando é diferente, e com o nome dele.
 *
 * As duas linhas têm o MESMO fundo e o respiro dividido entre elas: antes a
 * segunda tinha `pt-0` e outro tom de verde, e ficava colada na primeira.
 */

const TOLERANCIA = 0.005;

export const temItemForaDeVigencia = (vigente: number, contratado: number): boolean =>
  Math.abs((Number(contratado) || 0) - (Number(vigente) || 0)) > TOLERANCIA;

interface Props {
  vigente: number;
  contratado: number;
  fmt: (v: number) => string;
  /** Colunas antes da do valor (o rótulo ocupa todas). */
  colunasDoRotulo: number;
  /** Colunas vazias depois do valor (a edição tem a da lixeira). */
  colunasDepois?: number;
}

export default function RodapeMrrDaAssinatura({ vigente, contratado, fmt, colunasDoRotulo, colunasDepois = 0 }: Props) {
  const diferente = temItemForaDeVigencia(vigente, contratado);
  const vazias = Array.from({ length: colunasDepois }, (_, i) => <td key={i}></td>);
  return (
    <>
      <tr className='bg-green-500/10 border-t border-green-500/30'>
        <td colSpan={colunasDoRotulo} className={`px-3 pt-3 ${diferente ? 'pb-1' : 'pb-3'} text-right font-medium text-green-400`}>
          Subtotal MRR{diferente ? ' vigente hoje' : ''}:
        </td>
        <td className={`px-3 pt-3 ${diferente ? 'pb-1' : 'pb-3'} text-right font-bold text-green-400 whitespace-nowrap`}>R$ {fmt(vigente)}</td>
        {vazias}
      </tr>
      {diferente && (
        <tr className='bg-green-500/10'>
          <td colSpan={colunasDoRotulo} className='px-3 pt-1 pb-3 text-right text-xs text-slate-400'>
            Total contratado (com itens fora de vigência):
          </td>
          <td className='px-3 pt-1 pb-3 text-right text-xs text-slate-400 whitespace-nowrap'>R$ {fmt(contratado)}</td>
          {vazias}
        </tr>
      )}
    </>
  );
}
